import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NzI18nService, en_US, zh_CN } from 'ng-zorro-antd/i18n';
@Component({
  selector: 'app-app-footer',
  templateUrl: './app-footer.component.html',
  styleUrls: ['./app-footer.component.less']
})
export class AppFooterComponent implements OnInit {
  get country(): string | null {
    return localStorage.getItem('country');
  }

  get language(){
    let config: any = localStorage.getItem('template_config');
    if (config) {
      config = JSON.parse(config);
      return config?.language || 'zh'
    }
    return 'zh'
  }
  constructor(
    private translate: TranslateService,
    private router: Router,
    private i18n: NzI18nService
  ) { }

  ngOnInit(): void {

  }
  // language setting，
  changeLanguage(): void {
    const language = this.language === 'en' ? 'zh' : 'en';
    let config: any = localStorage.getItem('template_config');
    if (config) {
      config = JSON.parse(config);
      config = { ...config, language: language };
    } else {
      config = { language: language };
    }
    localStorage.setItem('template_config', JSON.stringify(config));
    this.translate.use(language);
    this.i18n.setLocale(language === 'en'? en_US : zh_CN);
    location.reload();
  }


  handleViewPrivacy(url: string, index?: number){
    const country = localStorage.getItem("country");
    this.router.navigate([`${country? country: '/iam'}${url}`],  {queryParams: { index: index}});
  }

  
  async showDockPrivacySettings() {
    await customElements.whenDefined("dock-privacy-settings");
    const dockPrivacySettings = document.querySelector("dock-privacy-settings");
    if (dockPrivacySettings) {
      await dockPrivacySettings.setAttribute("visible", "true");
      await dockPrivacySettings.setAttribute("link-url-policy", "Dealerportal/iam/myAccount/data-protection-policy?index=1");
      await dockPrivacySettings.setAttribute("link-url-imprint", "Dealerportal/iam/myAccount/data-protection-policy?index=0");
      await dockPrivacySettings.setAttribute("link-url-analysis", "Dealerportal/iam/myAccount/data-protection-policy?index=1");
      await dockPrivacySettings.setAttribute("link-url-marketing", "Dealerportal/iam/myAccount/data-protection-policy?index=1");
      await dockPrivacySettings.setAttribute("link-url-more-info", "Dealerportal/iam/myAccount/data-protection-policy?index=1");
    } else {
        console.error("dock-privacy-settings element not found");
    }
  }
        
}
